export const getBuilderWidgetClass = (builderWidgetId: string) => {
	return `w-${builderWidgetId}`
}

export const getPresetsInstanceWrapperClass = (instanceKey: string) => {
	return `${instanceKey}-presets-wrapper`
}

export const getPresetsInstanceWrapperSelector = (instanceKey: string) => {
	return `.${getPresetsInstanceWrapperClass(instanceKey)}`
}
